var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper -legal padding-menu"},[_c('div',{staticClass:"container",domProps:{"innerHTML":_vm._s(_vm.$t('legal_notice'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }